/**
 * A plain (non-React) accessor for the mini-app's live auth bearer.
 *
 * Exists for module-scope telemetry senders — `clientEventReporter.ts` today,
 * any future one — that cannot call a hook to reach `ClientEventContext`'s
 * reporter (that context is provided by `<ApiProvider>`, which only a React
 * subtree can consume). `useTelegramInitDataAuth` registers its session's own
 * `getAccessToken` here on mount, mirroring the identity-stable bound method
 * `ApiProvider` already trusts for the same reason.
 *
 * Answers `null` until a session registers (module-eval time, and the whole
 * `authMode === 'mock'` path never registers at all) — never a hang, never a
 * throw. `createClientEventReporter`'s `getAccessToken` is optional for
 * exactly this reason: an unauthenticated send is still useful telemetry,
 * not a fatal gap.
 */
let current: (() => Promise<string | null>) | null = null;

export function setLiveAccessTokenAccessor(fn: (() => Promise<string | null>) | null): void {
  current = fn;
}

export function getLiveAccessToken(): Promise<string | null> {
  return current ? current() : Promise.resolve(null);
}
